import { useTranslation } from 'react-i18next';
import { IssueTicket } from '../../config';
import {
  CommentFieldType,
  Form,
  UserAssignmentModal,
} from 'src/components/common/modals/user-assignment-modal';
import { DocumentNode } from 'graphql';
import { useMutation } from '@apollo/client';
import {
  CreateIssueCommentDocument,
  UpdateIssueTicketDocument,
} from 'src/graphql/generated/graphql';

type AssignModalProps = {
  issueTicket: IssueTicket;
  refetchQueries?: DocumentNode[];
  onClose: () => void;
};

export const AssignModal = ({
  issueTicket,
  refetchQueries = [],
  onClose,
}: AssignModalProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.list.actions.assign-modal',
  });

  const [updateIssueTicket, { loading: loadingUpdateIssue }] = useMutation(
    UpdateIssueTicketDocument,
    {
      refetchQueries,
    },
  );

  const [createIssueComment, { loading: loadingCreateComment }] = useMutation(
    CreateIssueCommentDocument,
    {
      refetchQueries,
    },
  );

  const onSave = async (data: Form) => {
    await updateIssueTicket({
      variables: {
        id: issueTicket.id,
        data: {
          assignedToUserId: data.assignedToUserId,
        },
      },
    });

    if (data.comment) {
      await createIssueComment({
        variables: {
          data: {
            comment: data.comment,
            issueTicketId: issueTicket.id,
          },
        },
      });
    }

    onClose();
  };

  return (
    <UserAssignmentModal
      title={t('title')}
      currentAssignment={issueTicket.assignedTo}
      commentField={CommentFieldType.Optional}
      onClose={onClose}
      onSave={onSave}
      loading={loadingUpdateIssue || loadingCreateComment}
    />
  );
};
